import React, {useState} from 'react';
import PropTypes from 'prop-types';
import CookieContext from './CookieContext';
import CookieManager from './CookieManager';

import type {CookieAdapter} from './CookieManager';
interface Props {
    children: React.ReactNode;
    adapter?: CookieAdapter;
    cookies: string;
}

const CookieProvider = ({children, adapter, cookies}: Props) => {
    const [cookieManager] = useState(() => new CookieManager(cookies, adapter));
    return (
        <CookieContext.Provider value={cookieManager}>
            {children}
        </CookieContext.Provider>
    );
};

CookieProvider.propTypes = {
    /** Adapter function used to write cookies in the browser; not used
     * server-side. Receives a raw cookie string value with any encoding or
     * options like `expires` already applied. Defaults to an adapter that
     * writes directly to document.cookie. Supply a different adapter to enforce
     * a GDPR cookie consent policy. This library exports a
     * `vrboCookieConsentAdapter` function that interacts with Vrbo's cookie
     * consent API. */
    adapter: PropTypes.func,
    /** String representing the initial cookies for this request / page load. In
     * the browser, you can pass `document.cookie` directly. On the server, pass
     * the cookie string from the request. */
    cookies: PropTypes.string.isRequired,
};

export default CookieProvider;
